import { Component } from '@angular/core';
import { BlockUIService } from 'ng-block-ui';

@Component({
  selector: 'block-temp',
  styles: [`
    :host {
      text-align: center;
      color: #fff;
    }
    `],
  templateUrl: './block-ui-template.html'
  })
  export class BlockUITemplateComponent {

    constructor(private blockUIService: BlockUIService) {

    }
  }
